import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useState } from '@redneckz/uni-jsx/lib/hooks';
import { useBool } from '@redneckz/uni-jsx/lib/hooks/useBool';
import { formatDate } from '../../utils/formatDate.js';
import { style } from '../../utils/style.js';
import { Icon } from '../Icon/Icon.js';
import { renderLabel } from '../Input/renderLabel.js';
import { Paragraph } from '../Paragraph/Paragraph.js';
import { Select } from '../Select/Select.js';
import { Calendar } from './Calendar.js';
import { months } from './months.js';
import { useDatePickerManager } from './useDatePickerManager.js';
const ICON_PROPS = {
    name: 'ArrowUpIcon',
    iconVersion: 'black',
    width: '24',
    height: '24',
};
const SELECT_PROPS = {
    className: 'min-w-32',
    iconVersion: 'black',
    isBorder: false,
};
const formStyle = 'flex justify-between items-center h-14 px-m py-s border rounded-md cursor-pointer ' +
    'hover:border-black active:border-black focus:border-black';
export const DatePicker = JSX(({ className = '', label = '', value, valid = true, minDate, maxDate, onChange }) => {
    const [showCalendar, { setValue }] = useBool(false);
    const [selectedMonth, setSelectedMonth] = useState(value?.getMonth() || new Date().getMonth());
    const [selectedYear, setSelectedYear] = useState(value?.getFullYear() || new Date().getFullYear());
    const { handlePrevMonth, handleNextMonth, handleSelectMonth, handleSelectYear, monthsOptions, yearsOptions, handleChangeVisibleCalendar, ref, } = useDatePickerManager({
        onYearSelect: setSelectedYear,
        onMonthSelect: setSelectedMonth,
        onShowCalendar: setValue,
        selectedYear,
        selectedMonth,
        showCalendar,
    });
    return (_jsxs("div", { className: style('space-y-xs', className), ref: ref, children: [renderLabel(label), _jsxs("div", { className: "relative", children: [renderDatePickerForm(handleChangeVisibleCalendar, value, valid), showCalendar ? (_jsxs("div", { className: "absolute bg-white z-20 select-none", children: [_jsxs("div", { className: "flex gap-s", children: [_jsx("div", { className: "my-auto", onClick: handlePrevMonth, children: _jsx(Icon, { ...ICON_PROPS, className: "-rotate-90 cursor-pointer" }) }), _jsx(Select, { onChange: handleSelectMonth, value: { key: months[selectedMonth] }, options: monthsOptions, ...SELECT_PROPS }), _jsx(Select, { onChange: handleSelectYear, value: { key: String(selectedYear) }, options: yearsOptions, ...SELECT_PROPS }), _jsx("div", { className: "my-auto", onClick: handleNextMonth, children: _jsx(Icon, { ...ICON_PROPS, className: "rotate-90 cursor-pointer" }) })] }), _jsx(Calendar, { today: value, currentMonth: selectedMonth, currentYear: selectedYear, onDateSelect: onChange, min: minDate, max: maxDate })] })) : null] })] }));
});
const renderDatePickerForm = (handleChangeVisibleCalendar, value, valid) => (_jsxs("div", { onClick: handleChangeVisibleCalendar, className: style(formStyle, valid ? 'border-gray' : 'border-error'), children: [_jsx(Paragraph, { children: value && formatDate(value) }), _jsx(Icon, { ...ICON_PROPS, name: "CalendarIcon" })] }));
//# sourceMappingURL=DatePicker.js.map